import BVASelect from "../../../components/BVASelect/BVASelect";
import {useState} from "react";
import ForecastedRevenue from "./ForecastedRev"
import ForecastedDOE from "./ForecastedDOE"
import ForecastedRC from "./ForecastedRC";
import ForecastedGWC from "./ForecastedGWC";
import ForecastedMGC from "./ForecastedMGC";
import ForecastedDepreciation from "./ForecastedDepreciation";
import ForecastedFCF from "./ForecastedFCF";
import CapitalizationOfEarnings from "./CapitalizationOfEarnings";
import ForecastedCTE from "./ForecastedCTE";
import CapitalizationRate from "./CapitalizationRate";
import GrowthForecast from "./GrowthForecastStageDCF";
import DiscountedCFM from "./DiscountedCFM";
import BalanceSheetCategory from "./BalanceSheet";
import Reconciliation from "./ReconciliationOfValuationMethods";

const FORECASTED_REVENUE = "FORECASTED_REVENUE"
const FORECASTED_DOE = "FORECASTED_DOE"
const FORECASTED_RC = "FORECASTED_RC"
const FORECASTED_GWC = "FORECASTED_GWC"
const FORECASTED_MGC = "FORECASTED_MGC"
const FORECASTED_DEPRECIATION = "FORECASTED_DEPRECIATION"
const FORECASTED_FCF = "FORECASTED_FCF"
const CAPITALIZTION_RATE = "CAPITALIZTION_RATE"
const FORECASTED_CTE = "FORECASTED_CTE"
const CAPITALIZTAION_OF_EARNINGS = "CAPITALIZTAION_OF_EARNINGS"
const GROWTH_FORECASTS = "GROWTH_FORECASTS"
const DISCOUNTED_CFM = "DISCOUNTED_CFM"
const BALANCE_SHEET_CATEGORY = "BALANCE_SHEET_CATEGORY"
const RECONCILIATION = "RECONCILIATION"

const selectSections = [
  { label: "Forecasted Revenue", value: FORECASTED_REVENUE },
  { label: "Forecasted Discretionary Owner Earnings", value: FORECASTED_DOE },
  { label: "Forecasted Reasonable Compensation", value: FORECASTED_RC },
  { label: "Forecasted Growth in Working Capital", value: FORECASTED_GWC },
  { label: "Forecasted Capital Expenditures", value: FORECASTED_MGC },//Forecasted Maintenance and Growth Capex
  { label: "Forecasted Depreciation", value: FORECASTED_DEPRECIATION },
  { label: "Forecasted Free Cash Flow", value: FORECASTED_FCF },
  { label: "Capitalization Rate", value: CAPITALIZTION_RATE },
  { label: "Forecasted Cash To Earnings", value: FORECASTED_CTE },
  { label: "Capitalization of Earnings", value: CAPITALIZTAION_OF_EARNINGS },
  { label: "Fundamental Growth Forecasts for 2 Stage DCF", value: GROWTH_FORECASTS },
  { label: "Discounted Cash Flow Method", value: DISCOUNTED_CFM },
  { label: "Adjusted Book Value", value: BALANCE_SHEET_CATEGORY },
  { label: "Reconciliation of Valuation Methods", value: RECONCILIATION },
]

export default function Valuation() {
  // States
  const [selectedSection, setSelectedSection] = useState(FORECASTED_REVENUE)

  // Methods
  const getSection = () => {
    switch(selectedSection) {
      case FORECASTED_REVENUE:
        return <ForecastedRevenue />

      case FORECASTED_DOE:
        return <ForecastedDOE />

      case FORECASTED_RC:
        return <ForecastedRC />
      
      case FORECASTED_GWC:
        return <ForecastedGWC />

      case FORECASTED_MGC:
        return <ForecastedMGC />

      case FORECASTED_DEPRECIATION:
        return <ForecastedDepreciation />

      case FORECASTED_FCF:
        return <ForecastedFCF />

      case CAPITALIZTION_RATE:
        return <CapitalizationRate />

      case FORECASTED_CTE:
        return <ForecastedCTE />

      case CAPITALIZTAION_OF_EARNINGS:
        return <CapitalizationOfEarnings />

      case GROWTH_FORECASTS:
        return <GrowthForecast />

      case DISCOUNTED_CFM:
        return <DiscountedCFM />

      case BALANCE_SHEET_CATEGORY:
        return <BalanceSheetCategory />

      case RECONCILIATION:
        return <Reconciliation />

      default:
        break
    }
  }

  return (
    <div>
      <div className="flex items-center">
        <BVASelect
            items={selectSections}
            value={selectedSection}
            width="24em"
            placeholder="Select a section"
            onChange={(value) => setSelectedSection(value)} />
      </div>
      <div className="mt-20">
        {getSection()}
      </div>
    </div>
  )
}
